// Changelog do SigaPsi.
// Para registrar nova versao: adicionar objeto no topo do array `versoes`.
// Tipos suportados em `mudancas`: 'novo' | 'melhoria' | 'fix'.

export const funcionalidadesAtuais = [
    {
        categoria: 'Pacientes',
        itens: [
            'Cadastro completo de pacientes com dados pessoais, endereco e nacionalidade',
            'Anexos por paciente (documentos, exames, fotos)',
            'Fila de espera',
        ],
    },
    {
        categoria: 'Agendamentos',
        itens: [
            'Calendario de sessoes com visao mensal/semanal/diaria',
            'Definicao de disponibilidade do psicologo',
            'Integracao com Google Calendar para gerar links do Meet',
        ],
    },
    {
        categoria: 'Documentos',
        itens: [
            'Editor de modelos com variaveis dinamicas (paciente, psicologo, datas)',
            'Geracao de documentos em PDF',
            'Historico de documentos gerados',
            'Aceite eletronico via link publico',
        ],
    },
    {
        categoria: 'Financeiro',
        itens: [
            'Contas a pagar e a receber',
            'Conta bancaria e planos de pagamento',
            'Historico financeiro',
        ],
    },
    {
        categoria: 'Relatorios',
        itens: [
            'Relatorios de psicologos, pacientes e contas a receber em PDF e CSV',
            'Visualizacao do PDF em modal e atalhos no menu lateral',
            'Formatacao automatica de CPF, telefone, CEP e CRP',
            'Total geral nas contas a receber',
        ],
    },
    {
        categoria: 'Assinaturas',
        itens: [
            'Assinaturas por paciente com renovacao automatica agendada',
            'Planos de atendimento e periodicidades',
            'Historico de renovacoes',
        ],
    },
    {
        categoria: 'Sistema',
        itens: [
            'Autenticacao JWT com sessao unica por usuario',
            'Criptografia AES-256 em campos sensiveis',
            'Auditoria via Hibernate Envers',
            'Notificacoes via WhatsApp (Evolution API)',
            'Status do sistema e historico de notificacoes',
        ],
    },
];

export const versoes = [
    {
        versao: '0.7.0',
        data: '2026-06-01',
        mudancas: [
            { tipo: 'novo', texto: 'Visualizacao de relatorios em modal com PDF embutido, no lugar de abrir em nova guia' },
            { tipo: 'novo', texto: 'Atalhos no menu lateral para cada relatorio (Psicologos, Pacientes, Contas a Receber) com PDF renderizado na propria pagina' },
            { tipo: 'melhoria', texto: 'Layout dos relatorios redesenhado: cabecalho com identificacao do consultorio, contagem de registros e listras alternadas' },
            { tipo: 'melhoria', texto: 'Formatacao automatica de CPF, telefone, CEP e CRP nos relatorios (PDF e CSV)' },
            { tipo: 'melhoria', texto: 'Total geral exibido no relatorio de contas a receber' },
            { tipo: 'melhoria', texto: 'JasperReports atualizado para a versao 7' },
            { tipo: 'fix', texto: 'Erro ao gerar relatorio nao desloga mais o usuario: mostra mensagem em vez de redirecionar ao login' },
        ],
    },
    {
        versao: '0.6.0',
        data: '2026-05-17',
        mudancas: [
            { tipo: 'novo', texto: 'Sessao finaliza automaticamente ao salvar evolucao (AGENDADA → REALIZADA)' },
            { tipo: 'novo', texto: 'Novo status REALIZADA_ALTERADA marca sessao editada apos finalizacao' },
            { tipo: 'novo', texto: 'Edicao de sessao finalizada exige senha do usuario logado' },
            { tipo: 'novo', texto: 'Lista de sessoes com abas por status (Agendadas, Realizadas, Alteradas, Faltas, Canceladas)' },
            { tipo: 'novo', texto: 'Cadeado em sessoes finalizadas + modal de confirmacao por senha' },
            { tipo: 'novo', texto: 'Visualizar conteudo completo das evolucoes pelo prontuario (anotacoes, tecnicas, avaliacao de risco)' },
            { tipo: 'novo', texto: 'Notificacao de novidades no menu lateral quando nova versao publicada' },
            { tipo: 'melhoria', texto: 'Tabela de prontuarios e sessoes nao quebra mais com nomes grandes (truncate + tooltip)' },
            { tipo: 'melhoria', texto: 'Salvar prontuario mantem usuario no formulario ao inves de voltar para lista' },
            { tipo: 'melhoria', texto: 'Aba "Agendadas" como filtro padrao da lista de sessoes' },
            { tipo: 'fix', texto: 'Avaliacao de risco duplicada a cada salvar (orphanRemoval no relacionamento)' },
            { tipo: 'fix', texto: 'Erro 409 ao salvar CID no prontuario (cascade no relacionamento Cid)' },
        ],
    },
    {
        versao: '0.5.0',
        data: '2026-05-16',
        mudancas: [
            { tipo: 'novo', texto: 'Pagina "Novidades" com changelog do sistema' },
        ],
    },
    {
        versao: '0.4.0',
        data: '2026-05-15',
        mudancas: [
            { tipo: 'novo', texto: 'Variaveis de endereco do paciente nos modelos de documento (ENDERECO, CIDADE, UF, CIDADE_UF, CEP_PACIENTE)' },
            { tipo: 'novo', texto: 'Placeholder DATA_EXTENSO e formatacao automatica de CPF, RG e CRP' },
            { tipo: 'novo', texto: 'Campo nacionalidade no cadastro de paciente e variaveis RG, PROFISSAO, ESTADO_CIVIL, NACIONALIDADE' },
            { tipo: 'novo', texto: 'Variavel CPF_PSICOLOGO disponivel no editor de modelos' },
            { tipo: 'fix', texto: 'montarEnderecoPaciente nao retorna vazio quando logradouro ausente' },
        ],
    },
];
